import * as React from 'react';
import { useSelector } from 'react-redux';

import { getIsAgent } from '../../../selectors/user';
import { AnnouncementForBuilder } from '../../AnnouncementForBuilder';

export const AnnouncementContainer = (): React.JSX.Element | null => {
  const isAgent = useSelector(getIsAgent);

  if (!isAgent) {
    return null;
  }

  return <AnnouncementForBuilder />;
};
